import { SalesOrderItemType } from '../constants/sales-order-item-type.js';
/**
 * Line types that represent a real, non-promotional product sale -- what counts toward purchase
 * history and the "frequently purchased" rollup. Excludes Sample/Promo (free goods), Credit
 * Return (a return is not a purchase: a received return's units are netted out of these totals
 * separately, see RECEIVED_CREDIT_RETURN_SALES_ORDER_STATUS_IDS), the adjustment types (no
 * productId), and Subtotal/Note/Misc Sale/Kit/BOM Configuration.
 */
export const PURCHASABLE_LINE_TYPES = new Set([
    SalesOrderItemType.SALE,
    SalesOrderItemType.DROP_SHIP,
]);
/** PURCHASABLE_LINE_TYPES plus Sample and Promo, for callers that opt giveaways back in. */
export const PURCHASABLE_LINE_TYPES_WITH_GIVEAWAYS = new Set([
    ...PURCHASABLE_LINE_TYPES,
    SalesOrderItemType.SAMPLE,
    SalesOrderItemType.PROMO,
]);
export function isPurchasableLineType(typeId, includeGiveaways = false) {
    return includeGiveaways
        ? PURCHASABLE_LINE_TYPES_WITH_GIVEAWAYS.has(typeId)
        : PURCHASABLE_LINE_TYPES.has(typeId);
}
//# sourceMappingURL=purchasable-line-types.js.map